import { ComptantBDL } from '../bdl/comptant';

export const ComptantServices = () => ({...ComptantBDL()});
